var _path, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoYouCare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 120 C160 105, 175 90, 190 90 C205 90, 220 105, 220 120 C220 105, 235 90, 250 90 C265 90, 280 105, 280 120 C280 135, 265 150, 250 165 L220 195 L190 165 C175 150, 160 135, 160 120 Z",
    fill: "none",
    stroke: "#696f71ff",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#626c73ff",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("line", {
    x1: 190,
    y1: 130,
    x2: 250,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 110,
    x2: 220,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 120,
    x2: 220,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 120,
    x2: 220,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 140,
    x2: 220,
    y2: 130
  }), /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 140,
    x2: 220,
    y2: 130
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 130,
    r: 3,
    fill: "#e74c3c"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 1.5,
    fill: "#f39c12",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 120,
    r: 1.5,
    fill: "#f39c12",
    opacity: 0.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 140,
    r: 1.5,
    fill: "#f39c12",
    opacity: 0.8
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 140,
    r: 1.5,
    fill: "#f39c12",
    opacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 130,
    r: 1.5,
    fill: "#27ae60",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "190;250",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;0",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 120,
    r: 1,
    fill: "#9b59b6",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "200;220",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "120;130",
    dur: "1.5s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.8;0",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 140,
    r: 1,
    fill: "#e67e22",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    values: "240;220",
    dur: "1.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "cy",
    values: "140;130",
    dur: "1.8s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0.8;0",
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 130,
    r: 8,
    fill: "none",
    stroke: "#3498db",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "8;16;8",
    dur: "3s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.3;0.1;0.3",
    dur: "3s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoYouCare);
export default __webpack_public_path__ + "static/media/DoYouCare.8054b89796208d5fdeba0fd6b2041acf.svg";
export { ForwardRef as ReactComponent };